// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cNxl","col":"styles_col__2DMw_"};